import { useMemo } from 'react';
import { View, useWindowDimensions } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Svg, { Rect, Path } from 'react-native-svg';

export default function FieldBackground() {
  const { width, height } = useWindowDimensions();

  const stripeWidth = 60;
  const stripesCount = Math.ceil(width / stripeWidth);

  // Generate alternating vertical stripes (mowed grass lines)
  const stripes = useMemo(() => {
    const list = [];
    for (let i = 0; i < stripesCount; i++) {
      const isEven = i % 2 === 0;
      list.push(
        <Rect
          key={i}
          x={i * stripeWidth}
          y={0}
          width={stripeWidth}
          height="100%"
          fill={isEven ? '#E6EFEA' : '#DEEAE2'}
        />
      );
    }
    return list;
  }, [stripesCount]);

  // Generate yard lines, hashes, and halftone risograph dot grid
  const paths = useMemo(() => {
    const linePathData = [];
    const hashPathData = [];
    const yardInterval = 160;
    const yardCount = Math.ceil(height / yardInterval);

    for (let i = 0; i < yardCount; i++) {
      const y = i * yardInterval;
      // Horizontal yard line
      linePathData.push(`M 0 ${y} L ${width} ${y}`);

      // Left hash mark
      const xLeft = width * 0.25;
      hashPathData.push(`M ${xLeft} ${y - 6} L ${xLeft} ${y + 6}`);

      // Right hash mark
      const xRight = width * 0.75;
      hashPathData.push(`M ${xRight} ${y - 6} L ${xRight} ${y + 6}`);
    }

    // Risograph halftone screen tone dot grid (dots spaced by 20px)
    const dotPathData = [];
    const dotSpacing = 20;
    for (let x = 10; x < width; x += dotSpacing) {
      for (let y = 10; y < height; y += dotSpacing) {
        dotPathData.push(`M ${x} ${y} l 0.1 0`);
      }
    }

    return {
      yardLines: linePathData.join(' '),
      hashes: hashPathData.join(' '),
      dots: dotPathData.join(' '),
    };
  }, [width, height]);

  return (
    <View style={StyleSheet.absoluteFill} pointerEvents="none">
      <Svg width="100%" height="100%">
        {stripes}

        {/* Faint yard lines */}
        {paths.yardLines ? (
          <Path
            d={paths.yardLines}
            stroke="rgba(255, 255, 255, 0.6)"
            strokeWidth={2}
          />
        ) : null}

        {/* Faint hash marks */}
        {paths.hashes ? (
          <Path
            d={paths.hashes}
            stroke="rgba(255, 255, 255, 0.6)"
            strokeWidth={2}
          />
        ) : null}

        {/* Halftone screen tone dot texture */}
        {paths.dots ? (
          <Path
            d={paths.dots}
            stroke="rgba(22, 36, 28, 0.04)"
            strokeWidth={3}
            strokeLinecap="round"
          />
        ) : null}
      </Svg>
    </View>
  );
}
